import { themePrimary } from 'shared/utils/cssUtility';
import { SvgIconType } from './svg.interface';

const ChooseType: SvgIconType = ({
  width = 388,
  height = 309,
  className = '',
  color = themePrimary
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="75 48 308 234"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_1_1174)">
      <path
        d="M375.42 158.79C328.33 187.75 186.09 270.38 186.09 270.38C176.49 276.03 164.49 275.69 155.23 269.49C155.23 269.49 100.39 232.19 82.06 219.83C76.94 216.38 75 207.5 81.03 201.63C130.12 173.12 277.21 87.22 277.21 87.22C286.8 81.62 296.64 83.83 305.93 89.9L375.94 136.09C382.2 140.18 384.42 153.25 375.41 158.8L375.42 158.79Z"
        fill="url(#paint0_linear_1_1174)"
      />
    </g>
    <path
      d="M375.42 158.79C328.33 187.75 186.09 270.38 186.09 270.38C176.49 276.03 164.49 275.69 155.23 269.49C155.23 269.49 100.39 232.19 82.06 219.83C76.94 216.38 75.5 209.5 81.03 201.63C130.12 173.12 277.21 87.22 277.21 87.22C286.8 81.62 296.64 83.83 305.93 89.9L375.94 136.09C382.2 140.18 384.42 153.25 375.41 158.8L375.42 158.79Z"
      fill="url(#paint1_linear_1_1174)"
    />
    <path
      d="M373.8 150.75C326.65 178.5 185.19 261.75 185.19 261.75C176.14 267.08 164.83 266.75 156.1 260.91L84.52 213.01C79.68 209.77 79.9 202.59 84.93 199.65L275.15 88.27C285.46 81.41 295.85 83.32 304.61 89.04L374.17 134.6C380.07 138.45 379.87 147.17 373.8 150.75Z"
      fill="#333333"
    />
    <path
      d="M370.97 149.29L183.54 258.36C174.94 263.42 164.2 263.11 155.9 257.56L86.75 211.06C82.15 207.98 82.36 201.16 87.14 198.37L275.29 88.21C283.88 83.2 294.56 83.46 302.89 88.9L371.33 133.96C376.94 137.62 376.75 145.9 370.97 149.3V149.29Z"
      fill={color}
    />
    <path
      d="M350.32 130.22L306.8 101.42C305 100.23 305.14 97.54 307.05 96.54L312.05 93.93L362.55 127.24L354.89 130.6C353.4 131.25 351.67 131.11 350.31 130.21L350.32 130.22Z"
      fill="url(#paint3_linear_1_1174)"
    />
    <path
      d="M344.74 121.03C344.74 121.87 343.91 122.55 342.88 122.55C341.85 122.55 341.02 121.87 341.02 121.03C341.02 120.19 341.85 119.51 342.88 119.51C343.91 119.51 344.74 120.19 344.74 121.03Z"
      fill="black"
    />
    <path
      d="M326.409 109.385L337.001 116.172C337.346 116.393 337.446 116.849 337.225 117.194L337.133 117.337C336.912 117.682 336.456 117.782 336.111 117.561L325.519 110.774C325.174 110.553 325.074 110.097 325.295 109.752L325.387 109.608C325.608 109.263 326.064 109.163 326.409 109.385Z"
      fill="black"
    />
    <path
      opacity="0.9"
      d="M163.5 216C163.5 218.266 162.122 220.379 159.769 221.948C157.418 223.515 154.143 224.5 150.5 224.5C146.857 224.5 143.582 223.515 141.231 221.948C138.878 220.379 137.5 218.266 137.5 216C137.5 213.734 138.878 211.621 141.231 210.052C143.582 208.485 146.857 207.5 150.5 207.5C154.143 207.5 157.418 208.485 159.769 210.052C162.122 211.621 163.5 213.734 163.5 216Z"
      fill="url(#paint4_radial_1_1174)"
      stroke="white"
    />
    <g clipPath="url(#clip0_1_1174)" filter="url(#filter1_ddd_1_1174)">
      <path
        d="M162.78 100H104.58C102.3 100 100 102.36 100 104.65V142.19C100 144.48 102.3 146 104.58 146H121.92L133.68 158.87L145.44 146H162.78C165.07 146 168 144.48 168 142.19V104.65C168 102.36 165.06 100 162.78 100Z"
        fill={color}
      />
      <path
        d="M142.4 110C143.885 110 145.31 110.577 146.36 111.603C147.41 112.63 148 114.022 148 115.474V126.421C148 127.873 147.41 129.265 146.36 130.292C145.31 131.319 143.885 131.895 142.4 131.895H135.786L129.12 135.805C128.919 135.923 128.691 135.989 128.457 135.999C128.223 136.008 127.99 135.96 127.78 135.859C127.57 135.758 127.39 135.607 127.255 135.42C127.12 135.233 127.035 135.016 127.008 134.788L127 134.632V131.895H125.6C124.163 131.895 122.781 131.355 121.74 130.388C120.699 129.42 120.079 128.098 120.007 126.695L120 126.421V115.474C120 114.022 120.59 112.63 121.64 111.603C122.69 110.577 124.115 110 125.6 110H142.4ZM136.8 122.316H128.4C128.029 122.316 127.673 122.46 127.41 122.717C127.147 122.974 127 123.322 127 123.685C127 124.047 127.147 124.396 127.41 124.652C127.673 124.909 128.029 125.053 128.4 125.053H136.8C137.171 125.053 137.527 124.909 137.79 124.652C138.052 124.396 138.2 124.047 138.2 123.685C138.2 123.322 138.052 122.974 137.79 122.717C137.527 122.46 137.171 122.316 136.8 122.316ZM139.6 116.842H128.4C128.029 116.842 127.673 116.986 127.41 117.243C127.147 117.5 127 117.848 127 118.211C127 118.574 127.147 118.922 127.41 119.178C127.673 119.435 128.029 119.579 128.4 119.579H139.6C139.971 119.579 140.327 119.435 140.59 119.178C140.853 118.922 141 118.574 141 118.211C141 117.848 140.853 117.5 140.59 117.243C140.327 116.986 139.971 116.842 139.6 116.842Z"
        fill="white"
      />
    </g>
    <g clipPath="url(#clip1_1_1174)" filter="url(#filter2_ddd_1_1174)">
      <path
        d="M243.78 50H185.58C183.3 50 181 52.36 181 54.65V92.19C181 94.48 183.3 96 185.58 96H202.92L214.68 108.87L226.44 96H243.78C246.07 96 249 94.48 249 92.19V54.65C249 52.36 246.06 50 243.78 50Z"
        fill={color}
      />
      <path
        d="M219.334 77.478L221.573 75.2383C221.875 74.9403 222.256 74.7364 222.672 74.6512C223.087 74.566 223.518 74.6032 223.912 74.7583L226.641 75.8482C227.039 76.0101 227.381 76.2863 227.623 76.6422C227.865 76.9981 227.996 77.4176 228 77.848V82.8474C227.998 83.1402 227.936 83.4294 227.819 83.6978C227.702 83.9661 227.532 84.208 227.319 84.4088C227.106 84.6097 226.855 84.7654 226.58 84.8665C226.306 84.9676 226.013 85.0121 225.721 84.9972C206.601 83.8073 202.743 67.6091 202.013 61.4098C201.979 61.1053 202.01 60.7972 202.104 60.5056C202.198 60.214 202.352 59.9455 202.557 59.7179C202.762 59.4903 203.013 59.3086 203.293 59.1849C203.573 59.0612 203.876 58.9982 204.182 59H209.01C209.441 59.0013 209.861 59.1315 210.217 59.3738C210.574 59.6162 210.849 59.9596 211.009 60.3599L212.098 63.0896C212.258 63.4826 212.299 63.9141 212.216 64.3303C212.132 64.7464 211.928 65.1287 211.628 65.4293L209.39 67.6691C209.39 67.6691 210.679 76.3981 219.334 77.478Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_1_1174"
        x="71.2909"
        y="83.996"
        width="316.128"
        height="202.395"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="6" />
        <feGaussianBlur stdDeviation="3" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1_1174"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1_1174"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_ddd_1_1174"
        x="0"
        y="50"
        width="268"
        height="258.87"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="5" />
        <feGaussianBlur stdDeviation="7.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1_1174"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="15" />
        <feGaussianBlur stdDeviation="17.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.235294 0 0 0 0 0.258824 0 0 0 0 0.341176 0 0 0 0.08 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_1_1174"
          result="effect2_dropShadow_1_1174"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="50" />
        <feGaussianBlur stdDeviation="50" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.235294 0 0 0 0 0.258824 0 0 0 0 0.341176 0 0 0 0.08 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_1_1174"
          result="effect3_dropShadow_1_1174"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect3_dropShadow_1_1174"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_ddd_1_1174"
        x="81"
        y="0"
        width="268"
        height="258.87"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="5" />
        <feGaussianBlur stdDeviation="7.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1_1174"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="15" />
        <feGaussianBlur stdDeviation="17.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.235294 0 0 0 0 0.258824 0 0 0 0 0.341176 0 0 0 0.08 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_1_1174"
          result="effect2_dropShadow_1_1174"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="50" />
        <feGaussianBlur stdDeviation="50" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.235294 0 0 0 0 0.258824 0 0 0 0 0.341176 0 0 0 0.08 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_1_1174"
          result="effect3_dropShadow_1_1174"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect3_dropShadow_1_1174"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_1_1174"
        x1="76.66"
        y1="179.19"
        x2="381.42"
        y2="179.19"
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset="0.08" stopColor="#1B1B1B" />
        <stop offset="0.24" stopColor="#48494A" />
        <stop offset="0.4" stopColor="#6E6F71" />
        <stop offset="0.56" stopColor="#8B8C8F" />
        <stop offset="0.71" stopColor="#A0A2A4" />
        <stop offset="0.86" stopColor="#ACAEB1" />
        <stop offset="1" stopColor="#B1B3B6" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1_1174"
        x1="76.66"
        y1="179.19"
        x2="307.78"
        y2="179.19"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.38" />
        <stop offset="0.4" stopColor="#191A1A" />
        <stop offset="0.43" stopColor="#3D3D3F" />
        <stop offset="0.47" stopColor="#5C5D5F" />
        <stop offset="0.51" stopColor="#77787A" />
        <stop offset="0.55" stopColor="#8C8E90" />
        <stop offset="0.6" stopColor="#9D9EA1" />
        <stop offset="0.67" stopColor="#A8AAAD" />
        <stop offset="0.75" stopColor="#AFB1B4" />
        <stop offset="1" stopColor="#B1B3B6" />
      </linearGradient>
      <radialGradient
        id="paint2_radial_1_1174"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(88.62 221.6) scale(288.94 288.94)"
      >
        <stop stopColor="#AFD7FD" />
        <stop offset="0.5" stopColor="#00C2FF" />
        <stop offset="1" stopColor="#318CF8" />
      </radialGradient>
      <linearGradient
        id="paint3_linear_1_1174"
        x1="305.53"
        y1="112.48"
        x2="362.56"
        y2="112.48"
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset="0.18" stopColor="#1E1E1F" />
        <stop offset="0.4" stopColor="#3B3C3D" />
        <stop offset="0.61" stopColor="#505152" />
        <stop offset="0.81" stopColor="#5C5D5F" />
        <stop offset="1" stopColor="#616264" />
      </linearGradient>
      <radialGradient
        id="paint4_radial_1_1174"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(150.5 216) scale(13.5 13.9153)"
      >
        <stop offset="0.345" stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="white" />
      </radialGradient>
      <linearGradient
        id="paint5_linear_1_1174"
        x1="102.952"
        y1="100.571"
        x2="159.341"
        y2="165.04"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0157A2" />
        <stop offset="0.791667" stopColor="#3AA5DC" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_1_1174"
        x1="183.952"
        y1="50.5715"
        x2="240.341"
        y2="115.04"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0157A2" />
        <stop offset="0.791667" stopColor="#3AA5DC" />
      </linearGradient>
      <clipPath id="clip0_1_1174">
        <rect
          width="68"
          height="58.87"
          fill="white"
          transform="translate(100 100)"
        />
      </clipPath>
      <clipPath id="clip1_1_1174">
        <rect
          width="68"
          height="58.87"
          fill="white"
          transform="translate(181 50)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default ChooseType;
